<script>
  import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
    } from 'sveltestrap';

  export let img=false;
  let open=false;
  const toggle = () => (img = !img);

  function onRightClick(e) { return false; }
  
  function getName(name) {
	name=name.split("/");
	name=name.slice(-1)[0].replaceAll(".jpg", "");
	name=name.replaceAll(".jpeg", "");
	name=name.replaceAll(".JPG", "");
	return name;
  }

  $: {
    if(img) { open=true; }
    else { open=false; }
  }
</script>

<Modal isOpen={open} toggle={toggle} scrollable size="lg">
  <ModalHeader toggle={toggle}>Náhled fotografie: {getName(img)}</ModalHeader>
  <ModalBody>
    <center><img src="{img}" style="max-width:600px;max-width:99%;max-height:80vh;" alt="fotografie" nosave on:contextmenu|preventDefault={onRightClick} /></center>
  </ModalBody>
</Modal>
